module.exports = __webpack_public_path__ + "img/splitter-north.39168341.png";